import { render, staticRenderFns } from "./webGl.vue?vue&type=template&id=cb25c87c&"
import script from "./webGl.vue?vue&type=script&lang=js&"
export * from "./webGl.vue?vue&type=script&lang=js&"
import style0 from "./webGl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports